import { render, staticRenderFns } from "./list-order-confirm-btn.vue?vue&type=template&id=5c406e0a&"
import script from "./list-order-confirm-btn.vue?vue&type=script&lang=js&"
export * from "./list-order-confirm-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports